import React from 'react';
import {SiteContentContext} from '../../context/SiteContentContext';
import {getMediaUrl} from '../../services/api';
import {Link} from 'react-router-dom';
import { IoMdCall } from "react-icons/io";
import { IoIosMail } from "react-icons/io";
import { IoLocationSharp } from "react-icons/io5"

export default class FooterOne extends React.Component {
    static contextType = SiteContentContext;
    render(){
        const {content,contact}=this.context;
        const footer=content.footer;
        if(!footer||!contact)return null;
        let publicUrl = process.env.PUBLIC_URL+'/'
        return (
            <>
                <footer className="footer-one-sec">
                    <div className="footer-one__pattern" style={{backgroundImage: 'url('+publicUrl+'assets/images/pattern/footer-v1-pattern.png)'}}></div>
                    <div className="footer-one__top">
                        <div className="footer-one__top-img"
                            style={{backgroundImage: 'url('+publicUrl+'assets/images/resources/footer-crane.png)'}}></div>
                        <div className="container-fluid px-4">
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="footer-one__top-inner">
                                        <div className="row">
                                            <div className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp" data-wow-delay="0.1s">
                                                <div className="footer-widget__column footer-widget__about">
                                                    <div className="footer-widget__about-logo">
                                                        <Link to={`${publicUrl}`} className="logo-container"><img className='img-fluid' style={{maxWidth : "100px"}} src={getMediaUrl(footer.logo)} alt="Logo" /></Link>
                                                    </div>

                                                    <p className="footer-widget__about-text">{footer.description}</p>

                                                    <div className="footer-widget__about-social-link">
                                                        <ul>
                                                            <li>
                                                                <a href={footer.facebook || undefined} rel="noopener noreferrer"target='_blank'>
                                                                    <span className="first icon-facebook-app-symbol"></span>
                                                                    <span className="second icon-facebook-app-symbol"></span>
                                                                </a>
                                                            </li>

                                                            <li>
                                                                <a href={footer.instagram || undefined} rel="noopener noreferrer" target = "_blank">
                                                                    <span className="first fa-brands fa-instagram"></span>
                                                                    <span className="second fa-brands fa-instagram"></span>
                                                                </a>
                                                            </li>

                                                            
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-xl-2 col-lg-6 col-md-6 wow animated fadeInUp" data-wow-delay="0.3s">
                                                <div className="footer-widget__column footer-widget__services">
                                                    <h2 className="footer-widget__title">Quick Links</h2>
                                                    <ul className="footer-widget__services-list">{footer.quickLinks.map((link,i)=><li key={i} className="footer-widget__services-list-item"><a href={link.url}>{link.label}</a></li>)}</ul>
                                                </div>
                                            </div>

                                            <div className="col-xl-2 col-lg-6 col-md-6 wow animated fadeInUp" data-wow-delay="0.5s">
                                                <div className="footer-widget__column footer-widget__explore">
                                                    <h2 className="footer-widget__title text-nowrap">Our Services</h2>
                                                    <ul className="footer-widget__explore-list">{footer.serviceLinks.map((link,i)=><li key={i} className="footer-widget__explore-list-item"><a href={link.url}>{link.label}</a></li>)}</ul>
                                                </div>
                                            </div>

                                            <div className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp" data-wow-delay="0.7s">
    <div className="footer-widget__column footer-widget__posts">
        <h2 className="footer-widget__title">Contact Us</h2>
        <div className="footer-contact-container">

            <div className="footer-contact-item d-flex align-items-center"> {/* Changed center to start */}
    <div className="icon-box">
        <IoLocationSharp className="footer-contact-icon" />
    </div>
    <div className="contact-details">
        <span className="contact-label">Location</span>
        <p className='text-white' style={{ margin: 0, lineHeight: '1.5' }}>
            {footer.location}
        </p>
    </div>
</div>
            
            {/* Call Item */}
            <div className="footer-contact-item d-flex align-items-center">
                <div className="icon-box">
                    <IoMdCall className="footer-contact-icon" />
                </div>
                <div className="contact-details">
                    <span className="contact-label">Call Us</span>
                    <a href={"tel:"+contact.phone} className="contact-value">{contact.phone}</a>
                </div>
            </div>
           {/* Email  */}
            <div className="footer-contact-item d-flex align-items-center">
                <div className="icon-box">
                    <IoIosMail className="footer-contact-icon" />
                </div>
                <div className="contact-details">
                    <span className="contact-label">Email Us</span>
                    <a href={"mailto:"+contact.email} className="contact-value">{contact.email}</a>
                </div>
            </div>
            
        </div>
    </div>
</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="footer-one__bottom clearfix">
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="footer-one__bottom-inner">
                                        <div className="footer-one__bottom-text">
                                            <p>{footer.copyright.replace(footer.creditText, "")} <a href={footer.creditUrl} target="_blank" rel="noopener noreferrer">{footer.creditText}</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </>
        )
    }
}